/* Kook v10 experience enhancements. Native theme and deposit controller are preserved. */

/* home.js */
/* Homepage actions and rental steps use native links; no JavaScript is needed. */


;

/* catalog.js */
/* Kook catalogue controls: preserve native Shopify filtering, URLs and sorting. */
(function (win, doc) {
  'use strict';
  if (win.KookCatalogUX) return;
  win.KookCatalogUX = true;
  const wide = win.matchMedia('(min-width: 769px)');
  const states = new Map();
  const watched = new WeakSet();
  let nativeCollectionPatched = false;
  let historyRevision = 0;
  const pendingNativeFilters = new Set();
  function waitForNativeFilters() {
    if (!pendingNativeFilters.size) return Promise.resolve();
    return Promise.allSettled(Array.from(pendingNativeFilters)).then(waitForNativeFilters);
  }

  function connectNativeCollection() {
    const prototype = win.theme?.Collection?.prototype;
    if (nativeCollectionPatched || !prototype || !doc.querySelector('[data-kook-catalog-controls]')) return;
    const init = prototype.init;
    const ajax = win.theme.CollectionAjaxFilter;
    win.theme.CollectionAjaxFilter = function () {
      const result = ajax.apply(this, arguments);
      const task = Promise.resolve(result);
      pendingNativeFilters.add(task);
      task.then(function () { pendingNativeFilters.delete(task); }, function () { pendingNativeFilters.delete(task); });
      return result;
    };
    prototype.init = function () {
      // Native section reinitialization adds a new unnamespaced sort handler.
      // Remove its preceding tracked handler before the native method adds one.
      const sort = doc.querySelector('[data-kook-catalog-controls] #SortBy');
      if (sort && typeof sort.off === 'function') sort.off('change');
      return init.apply(this, arguments);
    };
    prototype.bindBackButton = function () {
      const namespace = this.namespace;
      let previous = win.location.pathname + win.location.search;
      win.off('popstate' + namespace);
      win.on('popstate' + namespace, function () {
        const current = win.location.pathname + win.location.search;
        if ((current === previous && !pendingNativeFilters.size) || !doc.querySelector('[data-kook-catalog-controls]')) return;
        previous = current;
        // Keep native section fetching/reinitialization. A history traversal must
        // not push a new entry or replace other code's history.state fields.
        const revision = ++historyRevision;
        const params = new win.URLSearchParams(win.location.search);
        // Let an older native response finish before restoring a history entry;
        // otherwise that response can overwrite the Back/Forward result later.
        waitForNativeFilters().then(function () {
          if (revision !== historyRevision || current !== win.location.pathname + win.location.search) return;
          return win.theme.CollectionAjaxFilter(params, false).then(function () {
            if (revision === historyRevision) doc.dispatchEvent(new win.CustomEvent('collection:reloaded'));
          });
        }).catch(function () {
          if (revision === historyRevision && current === win.location.pathname + win.location.search) win.location.reload();
        });
      });
    };
    const grid = doc.getElementById('CollectionGrid');
    if (grid) prototype.bindBackButton.call({ namespace: '.collection-' + grid.getAttribute('data-section-id') });
    nativeCollectionPatched = true;
  }

  function stateFor(controls) {
    const key = controls.getAttribute('data-kook-catalog-id');
    if (!states.has(key)) states.set(key, { open: false, focus: null, element: null });
    return states.get(key);
  }
  function apply(controls) {
    const panel = controls.querySelector('[data-kook-filter-panel]');
    const toggle = controls.querySelector('[data-kook-filter-toggle]');
    if (!panel || !toggle) return;
    const state = stateFor(controls);
    panel.open = wide.matches || state.open;
    controls.setAttribute('data-kook-catalog-enhanced', 'true');
    toggle.hidden = wide.matches;
    toggle.setAttribute('aria-expanded', String(panel.open));
    const count = controls.querySelector('[data-kook-filter-count]');
    const active = Number(panel.getAttribute('data-active-count')) || 0;
    if (count) count.textContent = active ? '(' + active + ')' : '';
    const close = controls.querySelector('[data-kook-close-filters]');
    if (close) close.hidden = wide.matches;
    const wrapper = controls.querySelector('#CollectionFiltersSection');
    if (wrapper && !watched.has(wrapper)) {
      watched.add(wrapper);
      new win.MutationObserver(function () { apply(controls); }).observe(wrapper, { childList: true });
    }
  }
  function scan() { connectNativeCollection(); doc.querySelectorAll('[data-kook-catalog-controls]').forEach(apply); }
  function setOpen(controls, open, returnFocus) {
    stateFor(controls).open = open;
    apply(controls);
    if (returnFocus) controls.querySelector('[data-kook-filter-toggle]')?.focus();
  }
  function remember(event) {
    const target = event.target;
    if (!target || !target.closest) return;
    const controls = target.closest('[data-kook-catalog-controls]');
    if (!controls) return;
    const state = stateFor(controls);
    if (target.closest('.tag-list--active-tags a')) state.focus = { toggle: true };
    else if (target.closest('.filter-form')) {
      const slider = target.closest('.noUi-handle');
      if (slider) state.focus = { slider: Array.from(controls.querySelectorAll('.noUi-handle')).indexOf(slider) };
      else if (target.id) state.focus = { id: target.id };
      else if (target.name) state.focus = { name: target.name, value: target.value };
      else return;
    } else return;
    state.element = doc.activeElement;
  }
  function restore(controls) {
    const state = stateFor(controls);
    if (!state.focus) return;
    const active = doc.activeElement;
    // A shopper who moved to another control while the request ran keeps focus.
    if (active && active !== doc.body && active.isConnected && active !== state.element) {
      state.focus = null; state.element = null; return;
    }
    const panel = controls.querySelector('[data-kook-filter-panel]');
    const token = state.focus;
    let target = null;
    if (panel && panel.open && !token.toggle) {
      if (token.id) target = doc.getElementById(token.id);
      else if (token.slider !== undefined) target = controls.querySelectorAll('.noUi-handle')[token.slider];
      else target = Array.from(controls.querySelectorAll('input,select')).find(input => input.name === token.name && input.value === token.value);
    }
    if (!target || !controls.contains(target)) target = controls.querySelector('[data-kook-filter-toggle]');
    if (target && !target.hidden) target.focus({ preventScroll: true });
    state.focus = null; state.element = null;
  }
  doc.addEventListener('input', remember, true);
  doc.addEventListener('pointerdown', remember, true);
  doc.addEventListener('click', function (event) {
    const target = event.target;
    if (!target || !target.closest) return;
    const controls = target.closest('[data-kook-catalog-controls]');
    if (!controls) return;
    if (target.closest('[data-kook-filter-toggle]')) {
      event.preventDefault();
      setOpen(controls, !controls.querySelector('[data-kook-filter-panel]')?.open, false);
    } else if (target.closest('[data-kook-close-filters]')) {
      event.preventDefault(); setOpen(controls, false, true);
    } else remember(event);
  }, true);
  doc.addEventListener('toggle', function (event) {
    const panel = event.target;
    if (!panel.matches || !panel.matches('[data-kook-filter-panel]') || wide.matches) return;
    const controls = panel.closest('[data-kook-catalog-controls]');
    if (!controls) return;
    stateFor(controls).open = panel.open;
    controls.querySelector('[data-kook-filter-toggle]')?.setAttribute('aria-expanded', String(panel.open));
  }, true);
  doc.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') remember(event);
    if (event.key !== 'Escape' || wide.matches) return;
    const controls = event.target.closest && event.target.closest('[data-kook-catalog-controls]');
    if (!controls || !controls.querySelector('[data-kook-filter-panel]')?.open) return;
    event.preventDefault(); event.stopPropagation(); setOpen(controls, false, true);
  });
  doc.addEventListener('collection:reloaded', function () { scan(); doc.querySelectorAll('[data-kook-catalog-controls]').forEach(restore); });
  doc.addEventListener('shopify:section:load', scan);
  if (wide.addEventListener) wide.addEventListener('change', scan); else wide.addListener(scan);
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', scan, { once: true }); else scan();
})(window, document);


;

/* product.js */
/* Product quantity controls wrap the existing native form-associated input.
   Rental Units and BTA's hidden charged-day quantity are never selected. */
(() => {
  'use strict';
  if (window.KookProductQuantity) return;
  window.KookProductQuantity = true;

  function inputFor(control) {
    const kind = control.closest('[data-kook-product-kind]')?.dataset.kookProductKind;
    if (kind !== 'purchase' && kind !== 'gift-card') return null;
    const input = control.querySelector('input[type="number"][name="quantity"][form]');
    if (!input || input.disabled || input.hidden || input.closest('[hidden], [data-kook-booking]')) return null;
    if (input.getAttribute('form') !== control.dataset.kookProductQuantity || input.form?.getAttribute('id') !== control.dataset.kookProductQuantity) return null;
    return input;
  }

  function sync(control) {
    const input = inputFor(control);
    const min = input?.min === '' ? 1 : Number(input?.min);
    const max = input?.max === '' ? Infinity : Number(input?.max);
    const value = Number(input?.value);
    control.querySelectorAll('[data-kook-product-quantity-step]').forEach(button => {
      const decrease = Number(button.dataset.kookProductQuantityStep) < 0;
      button.disabled = !input || !Number.isFinite(value) || (decrease ? value <= min : value >= max);
    });
  }

  function connect(scope = document) {
    scope.querySelectorAll('[data-kook-product-quantity]').forEach(sync);
  }

  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-kook-product-quantity-step]');
    const control = button?.closest('[data-kook-product-quantity]');
    if (!control) return;
    event.preventDefault();
    const input = inputFor(control);
    const step = Number(button.dataset.kookProductQuantityStep);
    if (!input || button.disabled || (step !== -1 && step !== 1)) return;
    try { input.stepUp(step); } catch (_) { return; }
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    sync(control);
    if (button.disabled) input.focus({ preventScroll: true });
  });

  ['input', 'change'].forEach(type => document.addEventListener(type, event => {
    const control = event.target.closest?.('[data-kook-product-quantity]');
    if (control) sync(control);
  }));
  document.addEventListener('shopify:section:load', event => connect(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => connect(), { once: true });
  else connect();
})();


;

/* cart.js */
/* Display-only cart confirmation. Financial and booking controllers stay separate. */
(() => {
  'use strict';
  if (window.KookCartConfirmation) return;
  window.KookCartConfirmation = true;

  function confirmation(form, button) {
    let region = form.querySelector('[data-kook-add-confirmation]');
    if (region) return region;
    region = document.createElement('div');
    region.className = 'kook-add-confirmation';
    region.setAttribute('data-kook-add-confirmation', '');
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    const buttons = button.closest('.payment-buttons');
    (buttons && form.contains(buttons) ? buttons : button).insertAdjacentElement('afterend', region);
    return region;
  }

  function connect(scope = document) {
    scope.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      const button = form.querySelector('.add-to-cart, [name="add"]');
      if (button) confirmation(form, button);
    });
  }

  function clear(form) {
    if (form instanceof HTMLFormElement) form.querySelector('[data-kook-add-confirmation]')?.replaceChildren();
  }

  document.addEventListener('submit', event => clear(event.target), true);
  document.addEventListener('ajaxProduct:error', event => clear(event.target));
  document.addEventListener('ajaxProduct:added', event => {
    const product = event.detail?.product;
    const button = event.detail?.addToCartBtn;
    if (!product || product.status >= 400 || !button?.isConnected ||
        !(product.id || (Array.isArray(product.items) && product.items.length))) return;
    const form = button.closest('form');
    if (!form) return;
    const region = confirmation(form, button);
    const message = document.createElement('span');
    message.textContent = 'Added to your cart.';
    const link = document.createElement('a');
    link.className = 'kook-add-confirmation__link';
    link.setAttribute('data-kook-view-cart', '');
    link.href = window.theme?.routes?.cartPage || `${window.Shopify?.routes?.root || '/'}cart`;
    link.textContent = 'View cart';
    // A normal link intentionally opens the full cart only after activation.
    // Native cart-icon controls remain the only way to open the drawer.
    region.replaceChildren(message, link);
  });
  document.addEventListener('shopify:section:load', event => connect(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => connect(), { once: true });
  else connect();
})();

